import { FormIdentifier } from './form-identifier.model';
import { Modifier } from 'app/entertainment/interfaces/modifier.interface';
export class Attachment implements Modifier {
  context: string;
  creationDate: Date;
  documentName: string;
  documentType: string;
  fileLink: string;
  fileName: string;
  formIdentifier: FormIdentifier;
  generation: number;
  isInternal: boolean;
   
  //#region Modifier Interface Implementation
  creator: string;
  updator: string;
  created: Date;
  updated: Date;
  //#endregion

  constructor(attachment?: any) {
    if (!attachment) {
      attachment = {};
    }

    // Strongly type non-primitive types
    this.context = attachment.context || null;
    this.creationDate = attachment.creationDate
      ? new Date(attachment.creationDate)
      : null;
    this.documentName = attachment.documentName || null;
    this.documentType = attachment.documentType || null;
    this.fileLink = attachment.fileLink || null;
    this.fileName = attachment.fileName || null;
    this.formIdentifier = attachment.formIdentifier
      ? new FormIdentifier(attachment.formIdentifier)
      : null;
    this.generation = attachment.generation || null;
    this.isInternal = attachment.isInternal || null;
  }
}
